module.exports = __webpack_public_path__ + "static/media/IMG_3604.eaa1df03.jpg";